import React from 'react';

const base = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  focusable: 'false',
};

export function FlameMark({ size = 22 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M12 2c.6 3.4-1.2 5-2.8 6.6C7.4 10.4 6 12.2 6 14.7A6 6 0 0 0 18 15c0-2.6-1.2-4.4-2.6-6.2-.5 1-1.2 1.7-2 2.1.5-3.2-.4-6.4-1.4-8.9Z"
        fill="url(#flame-gradient)"
      />
      <defs>
        <linearGradient id="flame-gradient" x1="12" y1="2" x2="12" y2="21">
          <stop offset="0" stopColor="#ffd87f" />
          <stop offset="0.55" stopColor="#ffb747" />
          <stop offset="1" stopColor="#ff8c26" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function SteamIcon({ size = 18 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M11.98 2a10 10 0 0 0-9.95 9.06l5.36 2.21a2.82 2.82 0 0 1 1.6-.49h.14l2.38-3.45v-.05a3.77 3.77 0 1 1 3.77 3.77h-.09l-3.4 2.42v.12a2.83 2.83 0 0 1-5.61.55l-3.83-1.58A10 10 0 1 0 11.98 2Zm-4.3 15.16-1.23-.51a2.13 2.13 0 0 0 1.1 1.04 2.12 2.12 0 0 0 2.79-1.13 2.11 2.11 0 0 0-1.14-2.78 2.13 2.13 0 0 0-1.6.01l1.27.53a1.56 1.56 0 1 1-1.2 2.88Zm10.13-6.9a2.51 2.51 0 1 0-5.02 0 2.51 2.51 0 0 0 5.02 0Zm-4.39 0a1.89 1.89 0 1 1 3.77 0 1.89 1.89 0 0 1-3.77 0Z" />
    </svg>
  );
}

export function PlayIcon({ size = 22 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M8 5.14v13.72a1 1 0 0 0 1.53.85l10.4-6.86a1 1 0 0 0 0-1.7L9.53 4.3A1 1 0 0 0 8 5.14Z" />
    </svg>
  );
}

export function MenuIcon(props) {
  return (
    <svg {...base} width="22" height="22" {...props}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  );
}

export function CloseIcon(props) {
  return (
    <svg {...base} width="22" height="22" {...props}>
      <path d="M6 6l12 12M18 6 6 18" />
    </svg>
  );
}

export function ChevronIcon(props) {
  return (
    <svg {...base} width="18" height="18" {...props}>
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

export function ExpandIcon(props) {
  return (
    <svg {...base} width="18" height="18" {...props}>
      <path d="M9 3H3v6M15 21h6v-6M21 9V3h-6M3 15v6h6" />
    </svg>
  );
}

export function TikTokIcon({ size = 18 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-1.84-2.48V9.77a5.7 5.7 0 1 0 4.93 5.63V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.24-1.48Z" />
    </svg>
  );
}

export function XIcon({ size = 17 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M17.53 3h3.06l-6.69 7.64L21.75 21h-6.16l-4.82-6.3L5.25 21H2.19l7.15-8.17L2.25 3h6.31l4.36 5.76L17.53 3Zm-1.07 16.14h1.69L7.62 4.76H5.8l10.66 14.38Z" />
    </svg>
  );
}

export function YouTubeIcon({ size = 19 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M21.58 7.19a2.51 2.51 0 0 0-1.77-1.77C18.25 5 12 5 12 5s-6.25 0-7.81.42A2.51 2.51 0 0 0 2.42 7.19C2 8.75 2 12 2 12s0 3.25.42 4.81a2.51 2.51 0 0 0 1.77 1.77C5.75 19 12 19 12 19s6.25 0 7.81-.42a2.51 2.51 0 0 0 1.77-1.77C22 15.25 22 12 22 12s0-3.25-.42-4.81ZM9.95 15.02V8.98L15.18 12l-5.23 3.02Z" />
    </svg>
  );
}

// Frame, lens, and flash as nested subpaths. evenodd punches each inner shape
// out of the one around it regardless of winding order, which keeps the glyph
// solid like the other social marks without hand-tuning path directions.
export function InstagramIcon({ size = 18 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      fillRule="evenodd"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M8 2h8a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6V8a6 6 0 0 1 6-6Z
           M8.3 3.9h7.4a4.4 4.4 0 0 1 4.4 4.4v7.4a4.4 4.4 0 0 1-4.4 4.4H8.3a4.4 4.4 0 0 1-4.4-4.4V8.3a4.4 4.4 0 0 1 4.4-4.4Z
           M12 7.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2Z
           M12 9.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6Z
           M17.2 5.65a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Z"
      />
    </svg>
  );
}

export const SOCIAL_ICONS = {
  YouTube: YouTubeIcon,
  Instagram: InstagramIcon,
  TikTok: TikTokIcon,
  X: XIcon,
};
